import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import { Rect } from 'src/containers/ProjectDiagram/types/tooltip';

export const ProjectDiagramTooltip: React.VFC<{
  children?: React.ReactNode;
  text: string;
  rect?: Rect;
  isOpen?: boolean;
  disabled?: boolean;
}> = ({ text, rect, isOpen, disabled, children }) => {
  const targetProps: React.HTMLAttributes<HTMLElement> | undefined = rect
    ? {
        style: {
          position: 'absolute',
          pointerEvents: 'none',
          top: `${rect.top}px`,
          left: `${rect.left}px`,
          width: `${rect.width}px`,
          height: `${rect.height}px`,
        },
      }
    : undefined;

  return (
    <Tooltip
      content={
        <div
          style={{
            whiteSpace: 'pre-line',
            textAlign: 'center',
          }}
        >
          {text}
        </div>
      }
      disabled={disabled}
      isOpen={isOpen}
      targetProps={targetProps}
      targetTagName="div"
      usePortal={false}
    >
      {children ?? <div />}
    </Tooltip>
  );
};
